<template>
  <div class="recommendations-overview">
    <gyra-spinner v-if="isLoading" />
    <template v-else>
      <template v-if="hasItems">
        <breadcrumb />

        <div class="top-banner">
          <div class="tb-title">
            <h3 class="sex-title">
              {{ `recommendations.titles.${getSex}` | translate }}
            </h3>
          </div>
          <div class="tb-content">
            <div class="tb-left">
              <p>{{ `recommendations.descriptions.${getSex}` | translate }}</p>
            </div>
            <div class="tb-right">
              <div
                class="store-image hidden"
                :style="{
                  backgroundImage: `url()})`
                }"
              ></div>
            </div>
          </div>
        </div>

        <div
          v-for="(recommendation, i) in recommendations"
          :key="i"
          class="recommendations-content"
        >
          <div v-if="recommendation.title" class="title-and-button">
            <div class="emoji-and-title">
              <h3>
                {{ recommendation.title | translate }}
              </h3>
            </div>

            <div
              @click="visitRecommendation(recommendation)"
              class="more-button"
            >
              {{ "recommendations.titles.see_more" | translate }}
            </div>
            <BIconArrowRightShort
              class="right-arrow"
              @click="visitRecommendation(recommendation)"
            />
          </div>
          <div v-if="recommendation.type === 'selection'" class="product-row">
            <product-card
              v-for="(product, j) in recommendation.items"
              :key="j"
              :product="product"
              @card-clicked="visitProductPage"
            />
          </div>
          <div
            v-else-if="recommendation.type === 'banner'"
            class="banner"
            @click="visitRecommendation(recommendation)"
          >
            <div class="banner-text">
              <h3>
                {{
                  `recommendations.titles.${recommendation.query.key}`
                    | translate
                }}
              </h3>
              <p>{{ recommendation.subtitle | translate }}</p>
              <p class="link">
                {{ "recommendations.titles.see_all" | translate }} >
              </p>
            </div>
          </div>
        </div>
      </template>
      <div v-else class="message">
        {{ "recommendations.messages.problem_loading" | translate }}
      </div>
    </template>
  </div>
</template>

<script>
import { getRecommendations } from "../services/api";
import ProductCard from "../components/molecules/product-card";
import GyraSpinner from "../components/atoms/gyra-spinner";
import { errorHandling } from "../mixins";
import { recommendationToNavigationResolver } from "../mixins/navigation/recommendationToNavigationResolver";
import { BIconArrowRightShort } from "bootstrap-vue";
import Breadcrumb from "../components/molecules/breadcrumb";

export default {
  name: "RecommendationsPage",
  mixins: [errorHandling, recommendationToNavigationResolver],
  components: { Breadcrumb, GyraSpinner, ProductCard, BIconArrowRightShort },
  data() {
    return {
      recommendations: [],
      isLoading: false
    };
  },
  methods: {
    async getRecommendations(sex) {
      this.isLoading = true;
      const response = await getRecommendations({ sex, numberOfItems: 4 });
      if (response.status === 200) {
        this.recommendations = response.data;
      } else {
        this.handleHttpError(response);
      }
      this.isLoading = false;
    },
    visitProductPage(product) {
      this.$router.push({
        name: "ProductPage",
        params: {
          name: product.name,
          id: product._id,
          sex: this.$route.params.sex
        }
      });
    },
    visitRecommendation(recommendation) {
      this.resolveRecommendationToNavigation(recommendation);
    }
  },
  computed: {
    hasItems() {
      return this.recommendations.length > 0;
    },
    getSex() {
      return this.$route.params.sex || "women";
    }
  },
  async beforeMount() {
    await this.getRecommendations(this.$route.params.sex);
  },
  async beforeRouteUpdate(to, from, next) {
    this.recommendations = [];
    await this.getRecommendations(to.params.sex);
    next();
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.recommendations-overview {
  min-height: 100vh;
  /*padding: 20px 5%;*/
  /*@media (min-width: 1600px) {*/
  /*  padding: 20px 10%;*/
  /*}*/
}
h3 {
  margin-top: 45px;
  font-weight: bold;
  line-height: 18px;
  font-size: 18px;
  @media (min-width: 1000px) {
    line-height: 32px;
    font-size: 32px;
  }
  @media (min-width: 1200px) {
    line-height: 46px;
    font-size: 46px;
  }
}
.product-row {
  margin: 20px $gyra-margin-sides-mobile 60px $gyra-margin-sides-mobile;

  @media (min-width: $gyra-breakpoint-lg) {
    margin: 20px $gyra-margin-sides 60px $gyra-margin-sides;
  }
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  @media (min-width: 910px) {
    flex-wrap: nowrap;
  }
}
.message {
  display: flex;
  justify-content: center;
  margin-top: 20%;
}

.hidden {
  display: none;
}

.banner {
  position: relative;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 500px;
  background-image: url("../../src/assets/images/banners/beach-dawn-dusk-ocean-189349_2020-08-30/beach-dawn-dusk-ocean-189349@3x.png");
  cursor: pointer;

  .banner-text {
    padding-top: 32px;
    @media (min-width: $gyra-breakpoint-md) {
      padding-top: 87px;
      padding-left: $gyra-margin-sides;
    }

    padding-left: $gyra-margin-sides-mobile;
    h3,
    p {
      color: white;
    }
    h3 {
      margin-top: 0;
      font-size: 30px;
      line-height: 1.67;
      @media (min-width: $gyra-breakpoint-md) {
        font-size: 50px;
      }
    }
    p {
      margin-top: 28px;
      font-size: 14px;
      width: 80vw;
      margin-left: 26px;
      @media (min-width: $gyra-breakpoint-md) {
        margin-left: 46px;
        font-size: 20px;
        width: 60vw;
      }
    }
    .link {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
.title-and-button {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  margin-left: $gyra-margin-sides-mobile;
  margin-right: $gyra-margin-sides-mobile;
  @media (min-width: $gyra-breakpoint-lg) {
    margin-left: $gyra-margin-sides;
    margin-right: $gyra-margin-sides;
  }
}

.more-button {
  margin-bottom: 8px;
  font-weight: 700;
  cursor: pointer;
  display: none;
  text-decoration: underline;
  @media (min-width: 660px) {
    display: block;
  }
}

.emoji-and-title {
  display: flex;
  flex-direction: row;

  h3:last-child {
    margin-left: 12px;
  }
}

.right-arrow {
  font-weight: bold;
  font-size: 24px;
  display: inline;
  cursor: pointer;
  margin-bottom: 8px;
  @media (min-width: 660px) {
    display: none;
  }
}

.top-banner {
  min-height: 319px;
  width: 100%;
  background-color: $gyra-grey-lightest;
  padding-top: 23px;

  .tb-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 $gyra-margin-sides-mobile;
    @media (min-width: $gyra-breakpoint-lg) {
      margin: 0 $gyra-margin-sides;
    }
  }

  .sex-title {
    font-size: 30px;
    @media (min-width: $gyra-breakpoint-lg) {
      font-size: 50px;
    }
    margin: 10px 0 20px 0;
  }
  .emoji {
    font-size: 50px;
  }

  .tb-content {
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    @media (min-width: $gyra-breakpoint-xl) {
      flex-direction: row;
    }
  }

  .tb-left {
    margin: 20px 40px 0 $gyra-margin-sides-mobile;
    @media (min-width: $gyra-breakpoint-lg) {
      margin: 40px 40px 0 $gyra-margin-sides;
    }
    @media (min-width: $gyra-breakpoint-xl) {
      margin: 0 40px 0 $gyra-margin-sides;
    }
    p {
      font-size: 12px;
      @media (min-width: $gyra-breakpoint-lg) {
        font-size: 16px;
      }
    }
  }

  .tb-right {
    @media (min-width: $gyra-breakpoint-lg) {
      margin-left: $gyra-margin-sides;
    }
    @media (min-width: $gyra-breakpoint-xl) {
      margin-right: $gyra-margin-sides;
    }
    margin-left: $gyra-margin-sides-mobile;

    .store-image {
      @media (min-width: $gyra-breakpoint-xl) {
        margin-top: -80px;
      }
      @media (min-width: $gyra-breakpoint-sm) {
        height: 280px;
        width: 530px;
      }

      margin-top: 0;
      height: 192px;
      width: 330px;
      border: 1px solid;
      border-radius: 20px;
    }
  }
}
</style>
